import React from 'react';
import { BookOpen } from 'lucide-react';
const MODULES = [{
  title: 'TOMO 1 – Entendiendo el sueño de tu bebé',
  desc: 'Cómo funciona realmente el sueño infantil y por qué no se parece al de un adulto.'
}, {
  title: 'TOMO 2 – Señales de sueño: la clave que casi nadie enseña',
  desc: 'Aprendé a dormirlo antes del llanto y el sobrecansancio.'
}, {
  title: 'TOMO 3 – Método Sueño Seguro y Responsivo',
  desc: 'Un enfoque suave, sin llanto inducido, basado en apego y regulación emocional.'
}, {
  title: 'TOMO 4 – El entorno ideal y las rutinas nocturnas',
  desc: 'Cómo crear un “interruptor biológico” del sueño.'
}, {
  title: 'TOMO 5 – Técnicas naturales para dormir al bebé',
  desc: 'Contención, ruido blanco, respiración, acompañamiento real.'
}, {
  title: 'TOMO 6 – Siestas, despertares nocturnos y plan de acción de 7 días',
  desc: 'Integrá todo con un plan claro para empezar a ver cambios reales.'
}];
export function Modules() {
  return <section className="py-16 px-4 bg-white" data-id="element-59">
      <div className="max-w-5xl mx-auto" data-id="element-60">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-12" data-id="element-61">
          📘 ¿Qué incluye exactamente el MegaPack?
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-62">
          {MODULES.map((mod, i) => <div key={i} className="flex gap-4 p-6 bg-gray-50 rounded-xl border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-63">
              <div className="flex-shrink-0" data-id="element-64">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-blue-600" data-id="element-65">
                  <BookOpen className="w-6 h-6" data-id="element-66" />
                </div>
              </div>
              <div data-id="element-67">
                <h3 className="font-bold text-lg text-gray-900 mb-2" data-id="element-68">
                  {mod.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-69">{mod.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-12" data-id="element-70">
          <p className="text-xl font-medium text-gray-800 mb-6" data-id="element-71">
            Todo organizado para que sepas qué hacer, cuándo y por qué.
          </p>
          <a href="https://checkout.mediosdigitalespro.online/cart/42525422551111:1" className="inline-flex items-center justify-center font-bold text-blue-600 hover:text-blue-800 text-lg underline decoration-2 underline-offset-4" data-id="element-72">
            👉 ACCEDER CON DESCUENTO
          </a>
        </div>
      </div>
    </section>;
}